<div class="container-fluid mt-4">
  <h5 id="Section4Title">Controls / Mitigation Installation</h5>
  <div
    class="flex-display justify-content-center no-gutters w-100 relative"
    *ngFor="let a of amendments"
    [ngClass]="{
      'border-amd': a > 0 && a == getLastAmendment(),
      'border-amd-old': a > 0 && a != getLastAmendment()
    }"
  >
    <span
      [ngClass]="{
        'amendment-title': a == getLastAmendment(),
        'amendment-title-old': a != getLastAmendment()
      }"
      *ngIf="a > 0"
      >Amendment {{ a }}</span
    >
    <div class="d-flex justify-content-center w-100">
      <div
        *ngFor="let s of getSignaturesByAmendment(a)"
        class="px-2 col-6"
        [ngClass]="{
          'col-20': getSignaturesByAmendment(a).length == 5,
          'col-3': getSignaturesByAmendment(a).length == 4,
          'col-4': getSignaturesByAmendment(a).length == 3
        }"
      >
        <button-signature
          #btnSign
          [roleId]="s.roles"
          [roleCodes]="s.roleCodes"
          [user]="s.approvedBy"
          [title]="s.name"
          [disabled]="s.disabled"
          [value]="s.approved"
          [showApprove]="s.approveAction"
          [showUnapprove]="s.unapproveAction"
          [showDisapprove]="s.disapproveAction"
          [date]="s.approvedOn"
          [showCancel]="s.cancel"
          [cancelID]="s.cancelID"
          [taskID]="s.taskId"
          [enabled]="s.enabled"
          (approve)="approve(s.taskId, s.approveActionId)"
          (unapprove)="unapprove(s.taskId, s.unapproveActionId)"
          (disapprove)="disapprove(s.taskId, s.disapproveActionId, $event)"
          (onError)="alert.error($event)"
        ></button-signature>
      </div>
    </div>
  </div>
</div>
